 export default function lookupFilterElements (namespace) {
  const self = this;

  self.getElementsMap = function() {
    const elementsMap = {
      searchTextInput: `#${namespace}searchText`,
      showAdditionalFilterInput: `#${namespace}showAdditionalFilter`,
      showDateRangeFilterInput: `#${namespace}showDateRange`,
      additionalFilterOuter: `#${namespace}additionalFilter`,
      itemsPerPageSelect: `#${namespace}itemsPerPage`,
      sortFieldHiddenInput: `#${namespace}sortField`,
      sortTypeHiddenInput: `#${namespace}sortType`,
      form: `#${namespace}filter-form`,
      clearFilters: `#${namespace}clearFilters`,
      tableHeaderItems: ".table-header-item",
      dateRangeFilter: `#${namespace}date-range`,
      filterFieldsSelect: `#${namespace}filterFields`,
      filterStatusCheckboxes: `#${namespace}filter-status a input[type="checkbox"]`,
      filterTypeCheckboxes: `#${namespace}filter-type a input[type="checkbox"]`,
      searchFilters: `#${namespace}searchFilters`,
      searchCriteria: `#${namespace}searchCriteria`
    };
    return elementsMap;
  };

  self.getDocElementsMap = function() {
    const docElementsMap = {
      modalFilterType: `#${namespace}filter-type`,
      modalFilterStatus: `#${namespace}filter-status`,
      modalFilterCancel: '#additional-filter-cancel',
      applyAddtionalFiltersModalBtn: `#additional-filter-apply`,
      additionalFilterModal: `#${namespace}additional-filter-modal`,
      dateRangeModal: `#${namespace}date-range-modal`,
      dateRangeModalTitle:`#${namespace}date-range-title`
    };
    return docElementsMap;
  };

}





// WEBPACK FOOTER //
// ./src/pages/common/lookupFilterElements.js